import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./PastQuestions.css";

const pastQuestionsData = [
  {
    level: "Level 1",
    subjects: [
      {
        code: "L1-PAS",
        title: "Probability & Mathematical Statistic",
        website: "IFOA website past question page",
        Link: "https://actuaries.org.uk/qualify/prepare-for-your-exams/past-exam-papers-and-examiners-reports ",
        questions: [
          { date: "2024 Semester 1", paper: "PAS-S1 2024", report: "PAS Solutions S1-2024", pdf: "PAS-S1-2024.pdf" },
          { date: "2024 Semester 2", paper: "PAS-S2 2024", report: "PAS Solutions S2-2024", pdf: "PAS-S2-2024.pdf" },
          { date: "2023 Semester 1", paper: "PAS-S1 2023", report: "PAS Solutions S1-2023", pdf: "PAS-S1-2023.pdf" },
          { date: "2023 Semester 2", paper: "PAS-S2 2023", report: "PAS Solutions S2-2023", pdf: "PAS-S2-2023.pdf" },
        ],
      },
      {
        code: "L1-AE",
        title: "Actuarial Economics",
        website: "IFOA website past question page",
        Link: "https://actuaries.org.uk/qualify/prepare-for-your-exams/past-exam-papers-and-examiners-reports ",
        questions: [
          { date: "2024 Semester 1", paper: "AE-S1 2024", report: "AE Solutions S1-2024", pdf: "AE-S1-2024.pdf" },
          { date: "2024 Semester 2", paper: "AE-S2 2024", report: "AE Solutions S2-2024", pdf: "AE-S2-2024.pdf" },
          { date: "2023 Semester 1", paper: "AE-S1 2023", report: "AE Solutions S1-2023", pdf: "AE-S1-2023.pdf" },
          { date: "2023 Semester 2", paper: "AE-S2 2023", report: "AE Solutions S2-2023", pdf: "AE-S2-2023.pdf" },
        ],
      },
      {
        code: "L1-AFR",
        title: "Actuarial Financial Reporting",
        website: "IFOA website past question page",
        Link: "https://actuaries.org.uk/qualify/prepare-for-your-exams/past-exam-papers-and-examiners-reports ",
        questions: [
          { date: "2024 Semester 1", paper: "AFR-S1 2024", report: "AFR_Solution_S1-2024", pdf: "AFR-S1-2024.pdf" },
          { date: "2024 Semester 2", paper: "AFR-S2 2024", report: "AFR_Solution_S2-2024", pdf: "AFR-S2-2024.pdf" },
          { date: "2023 Semester 1", paper: "AFR-S1 2023", report: "AFR_Solution_S1-2023", pdf: "AFR-S1-2023.pdf" },
          { date: "2023 Semester 2", paper: "AFR-S2 2023", report: "AFR_Solution_S2-2023", pdf: "AFR-S2-2023.pdf" },
          { date: "2022 Semester 2", paper: "AFR-S1 2022", report: "AFR_Solution_S1-2022", pdf: "AFR-S1-2023.pdf" },
          { date: "2022 Semester 2", paper: "AFR-S2 2022", report: "AFR_Solution_S2-2022", pdf: "AFR-S2-2023.pdf" },
          { date: "2021 Semester 2", paper: "AFR-S1 2021", report: "AFR_Solution_S1-2021", pdf: "AFR-S1-2023.pdf" },
          { date: "2021 Semester 2", paper: "AFR-S2 2021", report: "AFR_Solution_S2-2021", pdf: "AFR-S2-2023.pdf" },
          { date: "2020 Semester 2", paper: "AFR-S1 2020", report: "AFR_Solution_S1-2020", pdf: "AFR-S1-2023.pdf" },
          { date: "2020 Semester 2", paper: "AFR-S2 2020", report: "AFR_Solution_S2-2020", pdf: "AFR-S2-2023.pdf" },
        ],
      },
    ],
  },
  {
    level: "Level 2",
    subjects: [
      {
        code: "L2-FM",
        title: "Financial Mathematics",
        website: "ASSA website past questions page",
        Link: "https://www.actuarialsociety.org.za/student-zone/exams/past-exam-papers/",
        questions: [
          { date: "2024 Semester 1", paper: "FM-S1 2024", report: "FM-Solution-S1-2024", pdf: "FM-S1-2024.pdf" },
          { date: "2024 Semester 2", paper: "FM-S2 2024", report: "FM-Solution-S2-2024", pdf: "FM-S2-2024.pdf" },
          { date: "2023 Semester 1", paper: "FM-S1 2023", report: "FM-Solution-S1-2023", pdf: "FM-S1-2023.pdf" },
          { date: "2023 Semester 2", paper: "FM-S2 2023", report: "FM-Solution-S2-2023", pdf: "FM-S2-2023.pdf" },
          { date: "2022 Semester 1", paper: "FM-S1 2022", report: "FM-Solution-S1-2022", pdf: "FM-S1-2023.pdf" },
          { date: "2022 Semester 2", paper: "FM-S2 2022", report: "FM-Solution-S2-2022", pdf: "FM-S2-2023.pdf" },
          { date: "2021 Semester 1", paper: "FM-S1 2021", report: "FM-Solution-S1-2021", pdf: "FM-S1-2023.pdf" },
          { date: "2021 Semester 2", paper: "FM-S2 2021", report: "FM-Solution-S2-2021", pdf: "FM-S2-2023.pdf" },
          { date: "2020 Semester 1", paper: "FM-S1 2020", report: "FM-Solution-S1-2020", pdf: "FM-S1-2023.pdf" },
          { date: "2020 Semester 2", paper: "FM-S2 2020", report: "FM-Solution-S2-2020", pdf: "FM-S2-2023.pdf" },
        ],
      },
      {
        code: "L2-RSS",
        title: "Risk & Survival Statistic",
        website: "IFOA website past question page",
        Link: "https://actuaries.org.uk/qualify/prepare-for-your-exams/past-exam-papers-and-examiners-reports ",
        questions: [
          { date: "2024 Semester 1", paper: "RSS-S1 2024", report: "RSS Solutions S1-2024", pdf: "RSS-S1-2024.pdf" },
          { date: "2024 Semester 2", paper: "RSS-S2 2024", report: "RSS Solutions S2-2024", pdf: "RSS-S2-2024.pdf" },
          { date: "2023 Semester 1", paper: "RSS-S1 2023", report: "RSS Solutions S1-2023", pdf: "RSS-S1-2023.pdf" },
          { date: "2023 Semester 2", paper: "RSS-S2 2023", report: "RSS Solutions S2-2023", pdf: "RSS-S2-2023.pdf" },
        ],
      },
    ],
  },
];

const PastQuestions = () => {
  const [selectedSubject, setSelectedSubject] = useState(null);
  const navigate = useNavigate();


const goToPastQuestions = () => {
  navigate("/syllabus");
};

  return (
    <div >
        <section className="section-council">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">PAST QUESTIONS</h2>
      <div className="sectionbottom-line"></div>
      </section>
    <div className="card-seperation">
    <div className="past-questions-container">
        {pastQuestionsData.map((levelData, index) => (
          <div key={index} className="level-section">
            <h3 className="level-title">{levelData.level}</h3>
            <div className="card-container">
              {levelData.subjects.map((subject, idx) => (
                <div key={idx} className="card" onClick={() => setSelectedSubject(subject)}>
                  <h4 className="code">{subject.code}</h4>
                  <p className="subject">{subject.title}</p>
                </div>
              ))}
          </div>
        </div>
      ))}


      {selectedSubject && (
        <div className="modal-overlay" onClick={() => setSelectedSubject(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">{selectedSubject.code} Past Question</h3>
            <table className="past-questions-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Question Paper</th>
                  <th>Examiner’s Report</th>
                </tr>
              </thead>
              <tbody>
                {selectedSubject.questions.map((q, i) => (
                  <tr key={i}>
                    <td>{q.date}</td>
                    <td>
                      <a href={`/Past-Questions/${q.pdf}`} download className="download-link">
                        {q.paper}
                      </a>
                    </td>
                    <td>
                        <a href={`/Past-Questions/${q.report}.pdf`} download className="download-link">
                          {q.report}
                        </a>
                      </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="redirections">
              {selectedSubject && (
                <div className="redirections-data">
                <p>For older papers and solution visit the <b>{selectedSubject.website}</b>&nbsp; 
                <Link to={selectedSubject.Link} target="_blank" rel="noopener noreferrer">click to open page</Link></p>
                </div>
              )}
            </div>
            <button className="close-btn" onClick={() => setSelectedSubject(null)}>Close</button>
          </div>
        </div>
      )}

         </div>
              {/* Past Questions card as a separate section on the right */}
              <div className="past-questions-column">
                <div className="card past-question-card" onClick={goToPastQuestions}>
                  <h4 className="code">SYLLABUS</h4>
                  <p className="subject">Click here to view Syllabus</p>
                </div>
              </div>

    </div>
    </div>
    
  );
};

export default PastQuestions;
